import { fetchApi } from "@lib/api-fetcher";
import { API_ROUTES } from "@utils/constants";
import { reportError } from "@utils/errorReporting";

import validateInvoiceAddressesResponse from "../models/invoiceAddresses";
import type { TInvoiceAddresses } from "../types";
import mapInvoiceAddressesResponse from "../utils/mapInvoiceAddressesResponse";

const loadInvoiceAddresses = async (): Promise<TInvoiceAddresses | null> => {
  try {
    const response = await fetchApi({
      url: API_ROUTES.USER_INVOICE_ADDRESSES,
    });
    const addressResponse = validateInvoiceAddressesResponse(response.data);
    return mapInvoiceAddressesResponse(addressResponse);
  } catch (err) {
    reportError(err, { module: "order" });
    return null;
  }
};
export default loadInvoiceAddresses;
